import { useEffect } from 'react';
import { useColumnFilterRegistryContext } from '../context/useColumnFilterRegistryContext';

// Safari bug workaround: focus can get stuck on the sortable <th>
// so Enter triggers PrimeReact's sort instead of the filter.
// Attaching directly to the <th> claims Enter first and refocuses the trigger to match Chrome/Firefox (JS-1178).
export const useBooleanFilterSortGuard = (
  columnName: string,
  enabled: boolean
): void => {
  const { applyColumnFilter, getTriggerElement } =
    useColumnFilterRegistryContext();

  useEffect(() => {
    if (!enabled) return;

    const trigger = getTriggerElement(columnName);
    const header = trigger?.closest<HTMLElement>(
      '[data-p-sortable-column="true"]'
    );
    if (!trigger || !header) return;

    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key !== 'Enter' || event.target !== header) return;
      event.preventDefault();
      event.stopPropagation();
      applyColumnFilter(columnName);
      trigger.focus();
    };

    header.addEventListener('keydown', onKeyDown);
    return () => header.removeEventListener('keydown', onKeyDown);
  }, [columnName, enabled, applyColumnFilter, getTriggerElement]);
};
